import { render } from "./PerformanceView.vue?vue&type=template&id=6cb90686&scoped=true"
import script from "./PerformanceView.vue?vue&type=script&lang=js"
export * from "./PerformanceView.vue?vue&type=script&lang=js"

import "./PerformanceView.vue?vue&type=style&index=0&id=6cb90686&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cb90686"]])

export default __exports__